module.exports = __webpack_public_path__ + "static/media/avocado-food-fruit-svgrepo-com.adf79ed2.svg";